import { createContext, useContext } from 'react';

/**
 * L'oggetto contesto dei permessi, senza il provider.
 *
 * Sta in un modulo a parte perche' `PermissionContext.js` importa `permissionService`, e
 * con esso axios, che e' ESM: un componente che volesse solo iscriversi ai cambi di
 * permessi (via `useCan`) trascinerebbe axios in ogni suite di test che lo monta, e la
 * suite fallirebbe con «Cannot use import statement outside a module».
 */
export const PermissionContext = createContext(null);

/**
 * Il contesto, o `null` fuori dal provider invece di un errore. Serve a `useCan` e ai
 * pannelli che chiedono `refresh`: si montano anche nei test senza provider, dove il
 * gating e' dato dal mock di `RoleService`.
 */
export const useOptionalPermissions = () => useContext(PermissionContext);
